import React from 'react'
import * as PropTypes from 'prop-types'
import Select from 'components/forms/elements/select'
import usStateNames from 'utils/constants/us-state-names'
import noop from 'utils/noop'

const State = ({ label, name, required, updateValidationSet }) => {
  return (
    <Select updateValidationSet={updateValidationSet} required={required} name={name} label={label}>
      <option value='' disabled={required}>
        Select a state
      </option>
      {Object.keys(usStateNames).map(state => (
        <option key={state} value={usStateNames[state]}>
          {state}
        </option>
      ))}
    </Select>
  )
}

State.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  updateValidationSet: PropTypes.func,
}

State.defaultProps = {
  label: 'State',
  name: 'State',
  required: false,
  updateValidationSet: noop,
}

export default State
